export default __webpack_public_path__ + "static/media/lisia-bachar.604bc335.png";